import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '@/pages/login';
import { ChangePasswordPage } from '@/pages/change-password';
import GamesPage from '@/pages/games';
import VersionMappingsPage from '@/pages/version-mappings';
import MaintenancePage from '@/pages/maintenance';
import EnvironmentsPage from '@/pages/environments';
import GameBaseUrlsPage from '@/pages/game-base-urls';
import { GameCatalogPage } from '@/features/game-catalog/game-catalog-page';
import { DashboardLayout } from '@/components/layout/dashboard-layout';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { useAuth } from '@/lib/auth-context';

/**
 * Root app router. Auth gating via <ProtectedRoute />:
 *   - /login: public
 *   - /change-password: requires auth (first-login forced)
 *   - /* : requires auth + !must_change_password
 */
export default function App(): JSX.Element {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-muted-foreground">Loading…</p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/" element={<Navigate to="/games" replace />} />
            <Route path="/games" element={<GamesPage />} />
            <Route path="/games/:id/base-urls" element={<GameBaseUrlsPage />} />
            <Route path="/games/:id/catalog" element={<GameCatalogPage />} />
            <Route path="/version-mappings" element={<VersionMappingsPage />} />
            <Route path="/maintenance" element={<MaintenancePage />} />
            <Route path="/environments" element={<EnvironmentsPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
